export default __webpack_public_path__ + "static/media/dogFace.304576a1.png";